import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { posts } from '../../../data/blog-posts';
import { brands } from '../../../data/shop-brands';
import { products } from '../../../data/shop-products';
// import { categories } from '../../../data/shop-block-categories';
import { AuthService } from '../../auth.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Category } from '../../../app/shared/interfaces/category';
import { Product } from '../../../app/shared/interfaces/product';
import { Merchant } from '../../../app/shared/interfaces/merchant';
import { ScrollEvent } from 'ngx-scroll-event';

import { AfterViewInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { NoticeComponent } from '../../shared/dialog/notice/notice.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { CartService } from '../../shared/services/cart.service';
import { CloudData, CloudOptions } from 'angular-tag-cloud-module';

import ScrollHint from 'scroll-hint';

@Component({
    selector: 'app-home',
    templateUrl: './page-home-one.component.html',
    styleUrls: ['./page-home-one.component.scss'],
  	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHomeOneComponent implements OnInit, AfterViewInit, OnDestroy{
    loading = true;
    products = products;
    banner;
    // categories = categories;
    categories = []; //banner categories (popular categories)
    ScrollHint=('.js-scrollable');
    bannerCategoryLoad = false;
    posts = posts;
    brands = brands;
    showsidebar = false;
    public pageYOffset :number = -200;
    lang = "";
    categoryList: Category[] = [
       {url: 'assets/images/logos/logo-1.png', name:"womensFashion", en:'', zh:'', routerLink: '../shop/27'},
       {url: 'assets/images/logos/logo-2.png', name:"mensFashion", en:'', zh:'', routerLink: '../shop/28'},
       {url: 'assets/images/logos/logo-11.png', name:"fashionAccessories", en:'', zh:'', routerLink: '../shop/38'},
       {url: 'assets/images/logos/logo-3.png', name:"shoesAndBags", en:'', zh:'', routerLink: '../shop/30' },

       {url: 'assets/images/logos/logo-4.png', name:"sportsAndOutdoors", en:'', zh:'', routerLink: '../shop/31'},
       {url: 'assets/images/logos/logo-5.png', name:"homeAndLifestyle", en:'', zh:'', routerLink: '../shop/32'},
       {url: 'assets/images/logos/logo-6.png', name:"electronic", en:'', zh:'', routerLink: '../shop/33'},
       {url: 'assets/images/logos/logo-7.png', name:"tvAndHomeAppliances", en:'', zh:'', routerLink: '../shop/34'},
       {url: 'assets/images/logos/logo-8.png', name:"babiesAndToys", en:'', zh:'', routerLink: '../shop/35'},
       {url: 'assets/images/logos/logo-9.png', name:"healthAndBeauty", en:'', zh:'', routerLink: '../shop/36'},
       {url: 'assets/images/logos/logo-10.png', name:"weniSpecial", en:'', zh:'', routerLink: '../shop/37'},
   ];

   list1: Product[] = [];
   list2: Product[] = [];
   list3: Product[] = [];
   list4: Product[] = [];
   list5: Product[] = [];
   list6: Product[] = [];
   superLowDealList: Product[] = [];
   wenProductList: Product[] = [];
   weiniSpecialList: Product[] = [];
   virtualProductList: Product[] = [];
   pointSectionList: Product[] = [];
   merchants: Merchant[] = [];
   ppProductList = [];
   mltProductList = [];
   jdtProductList = [];
   euspProductList = [];
   newArrivalPage = 0;
   slideList = [];
    @ViewChild('top', {static: false}) topElement: ElementRef;
    @ViewChild('sld', {static: false}) sldElement: ElementRef;
    @ViewChild('fp', {static: false}) fpElement: ElementRef;
    @ViewChild('bs', {static: false}) bsElement: ElementRef;
    @ViewChild('pc', {static: false}) pcElement: ElementRef;
    @ViewChild('na', {static: false}) naElement: ElementRef;
    @ViewChild('trp', {static: false}) trpElement: ElementRef;


    public currentActive = 0;
    public topOffset: Number = null;
    public sldOffset: Number = null;
    public fpOffset: Number = null;
    public bsOffset: Number = null;
    public pcOffset: Number = null;
    public naOffset: Number = null;
    public trpOffset: Number = null;

    columns = [
        // {
        //     header: 'topRatedProducts',
        //     products: list4.slice(0, 3),
        //     en: "",
        //     zh: ""
        // },
        // {
        //     header: 'specialOffers',
        //     products: list5.slice(3, 6),
        //     en: "",
        //     zh: ""
        // },
        // {
        //     header: 'bestsellers',
        //     products: list6.slice(6, 9),
        //     en: "",
        //     zh: ""
        // }
    ];

    productList: any[] = [];
    flashSaleProductList = [];
    pendingFlashSaleProductList = [];
    interval;

    cloudOptions: CloudOptions = {
      // if width is between 0 and 1 it will be set to the width of the upper element multiplied by the value
      width: 1,
      // if height is between 0 and 1 it will be set to the height of the upper element multiplied by the value
      height: 200,
      overflow: false,
    };
  
    cloudData: CloudData[] = [
    ];
    ngOnInit(){

      this.route.queryParams.subscribe(params => {
          if(params['token'] != undefined && params['token'].length > 0){
            this.authService.setToken(params['token']);
            this.getProfile();
          }else if(params['sessionId'] != undefined && params['sessionId'].length > 0){
            // console.log(params['sessionId']);
            this.authService.loadingSso = true;
            this.checkSso(params['sessionId']);
          }
      });

      if(this.authService.first){
        // this.showNoticeDialog();
        this.authService.first = false;
      }

      this.lang = this.authService.getLocale();
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.lang = event.lang;
        // this.authService.setLocale(this.lang);
      });

      // this.initTranslate();

      // this.getCategoryList();

      // this.initTranslate();
      this.getHomeProductList();
      // this.getFlashSaleProductList("PENDING");
      this.getFlashSaleProductList("START");
      //this.startInterval();
      this.getProductSearchList();
      // setTimeout(() => {
      //
      // },5000);
    }

    ngAfterViewInit()

     {
        // this.topOffset = this.topElement.nativeElement.offsetTop;

        // this.topOffset = 0;
        // this.fpOffset = this.fpElement.nativeElement.offsetTop;
        // this.bsOffset = this.bsElement.nativeElement.offsetTop;
        // this.pcOffset = this.pcElement.nativeElement.offsetTop;
        // this.naOffset = this.naElement.nativeElement.offsetTop;
        // this.trpOffset = this.trpElement.nativeElement.offsetTop;
      }


  @HostListener('window:scroll', ['$event'])
  checkOffsetTop() {
    // console.log("window.pageYOffset : " + window.pageYOffset);
    // if (window.pageYOffset>= this.topOffset && window.pageYOffset < this.fpOffset) {
    //   console.log("1");
    //   this.currentActive = 1;
    // } else if (window.pageYOffset>= this.fpOffset && window.pageYOffset < this.bsOffset) {
    //   console.log("2");
    //   this.currentActive = 2;
    // } else if (window.pageYOffset>= this.bsOffset && window.pageYOffset < this.pcOffset) {
    //   console.log("3");
    //   this.currentActive = 3;
    // } else if (window.pageYOffset>= this.pcOffset && window.pageYOffset < this.naOffset) {
    //   console.log("4");
    //   this.currentActive = 4;
    // } else if (window.pageYOffset >= this.naOffset && window.pageYOffset < this.trpOffset )  {
    //   console.log("5");
    //   this.currentActive = 5;
    // } else if (window.pageYOffset  >= this.trpOffset )  {
    //   console.log("6");
    //     this.currentActive = 6;
    // } else {
    //   console.log("0");
    //   this.currentActive = 0;
    // }
  }


    featuredProducts = {
        loading: false,
        products: products.slice(),
        groups: [

            // {name: 'All', current: true},
            // {name: 'Power Tools', current: false},
            // {name: 'Hand Tools', current: false},
            // {name: 'Plumbing', current: false}

        ],

        timeout: null, // only for demo

        groupChange: group => {
            // only for demo
            this.featuredProducts.loading = true;

            clearTimeout(this.featuredProducts.timeout);

            this.featuredProducts.timeout = setTimeout(() => {
                const itemsArray = this.featuredProducts.products;
                const newItemsArray = [];
                while (itemsArray.length > 0) {
                    const randomIndex = Math.floor(Math.random() * itemsArray.length);
                    const randomItem = itemsArray.splice(randomIndex, 1)[0];
                    newItemsArray.push(randomItem);
                }
                this.featuredProducts.products = newItemsArray;
                this.featuredProducts.loading = false;
            }, 1000);
        }
    };

    newArrivals = {
        loading: false,
        products: products.slice(),
        groups: [
            // {name: 'All', current: true},
            // {name: 'Power Tools', current: false},
            // {name: 'Hand Tools', current: false},
            // {name: 'Plumbing', current: false}
        ],

        timeout: null, // only for demo

        groupChange: group => {
            // only for demo
            this.newArrivals.loading = true;

            clearTimeout(this.newArrivals.timeout);

            this.newArrivals.timeout = setTimeout(() => {
                const itemsArray = this.newArrivals.products;
                const newItemsArray = [];
                while (itemsArray.length > 0) {
                    const randomIndex = Math.floor(Math.random() * itemsArray.length);
                    const randomItem = itemsArray.splice(randomIndex, 1)[0];
                    newItemsArray.push(randomItem);
                }
                this.newArrivals.products = newItemsArray;
                this.newArrivals.loading = false;
            }, 1000);
        }
    };

    categoriesHeader= {
      header: "categories",
      en: "",
      zh: "",
    };

    featuredProductsHeader = {
      header: "featuredProducts",
      en: "",
      zh: "",
      
    };

    bestsellersHeader = {
      header: "bestsellers",
      en: "",
      zh: "",
    };

    popularCategoriesHeader = {
      header: "popularCategories",
      en: "",
      zh: "",
    };

    newArrivalsHeader = {
      header: "newArrivals",
      en: "",
      zh: "",
    };

    flashSaleHeader = {
      header: "flashSale",
      en: "",
      zh: "",
    };

    superLowDealHeader = {
      header: "superLowDeal",
      en: "",
      zh: "",
    };

    wenProductHeader = {
      header: "wenProduct",
      en: "",
      zh: "",
    };

    weiniSpecialHeader = {
      header: "weiniSpecial",
      en: "",
      zh: "",
    };

    ppHeader = {
      header: "ppHeader",
      en: "",
      zh: "",
    };

    mltHeader = {
      header: "mltHeader",
      en: "",
      zh: "",
    };

    jdtHeader = {
      header: "jdtHeader",
      en: "",
      zh: "",
      icon:"assets/images/categories/bags.jpg",
    };

    euspHeader = {
      header: "euspHeader",
      en: "",
      zh: "",
    };

    scrollToTop(){
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }


    scroll(el: HTMLElement) {
        el.scrollIntoView({  behavior: 'smooth' });
     }

     public handleScroll(event: ScrollEvent) {

        if ( event.isReachingTop  )  {
          this.showsidebar=false;
        }

        else if ( event.isReachingBottom ) {
            this.showsidebar=true;
        }
      }


    constructor(private translate: TranslateService, public authService: AuthService, public dialog: MatDialog, private route: ActivatedRoute,
    private cart: CartService, private changeDetectorRefs: ChangeDetectorRef) { }

    ngOnDestroy() {
      this.stopInterval();
      this.changeDetectorRefs.detach();
    }

    detectChange(){
      if(!this.changeDetectorRefs['destroyed']){
       this.changeDetectorRefs.detectChanges();
      }
    }

    initTranslate(){
      // this.translate.getTranslation("zh").subscribe(res => {
      //   this.authService.zh = res;
      //   this.columns.forEach(item => {
      //     item.zh = this.authService.zh.home[item.header];
      //   });
      //   this.categoryList.forEach(item => {
      //     item.zh = this.authService.zh.departmentsData[item.name];
      //   });
      //   this.featuredProductsHeader.zh = this.authService.zh.home[this.featuredProductsHeader.header];
      //   this.bestsellersHeader.zh = this.authService.zh.home[this.bestsellersHeader.header];
      //   this.popularCategoriesHeader.zh = this.authService.zh.home[this.popularCategoriesHeader.header];
      //   this.newArrivalsHeader.zh = this.authService.zh.home[this.newArrivalsHeader.header];
      // });
      // this.translate.getTranslation("en").subscribe(res => {
      //   this.authService.en = res;
      //   this.columns.forEach(item => {
      //     item.en = this.authService.en.home[item.header];
      //   });
      //   this.categoryList.forEach(item => {
      //     item.en = this.authService.en.departmentsData[item.name];
      //   });
      //   this.featuredProductsHeader.en = this.authService.en.home[this.featuredProductsHeader.header];
      //   this.bestsellersHeader.en = this.authService.en.home[this.bestsellersHeader.header];
      //   this.popularCategoriesHeader.en = this.authService.en.home[this.popularCategoriesHeader.header];
      //   this.newArrivalsHeader.en = this.authService.en.home[this.newArrivalsHeader.header];
      // });



      this.columns.forEach(item => {
        item.zh = this.authService.zh.home[item.header];
      });
      this.categoryList.forEach(item => {
        item.zh = this.authService.zh.departmentsData[item.name];
      });
      this.featuredProductsHeader.zh = this.authService.zh.home[this.featuredProductsHeader.header];
      this.bestsellersHeader.zh = this.authService.zh.home[this.bestsellersHeader.header];
      this.popularCategoriesHeader.zh = this.authService.zh.home[this.popularCategoriesHeader.header];
      this.newArrivalsHeader.zh = this.authService.zh.home[this.newArrivalsHeader.header];
      this.superLowDealHeader.zh = this.authService.zh.home[this.superLowDealHeader.header];
      this.wenProductHeader.zh = this.authService.zh.home[this.wenProductHeader.header];
      this.weiniSpecialHeader.zh = this.authService.zh.home[this.weiniSpecialHeader.header];
      this.flashSaleHeader.zh = this.authService.zh.home[this.flashSaleHeader.header];
      this.ppHeader.zh = this.authService.zh.home[this.ppHeader.header];
      this.mltHeader.zh = this.authService.zh.home[this.mltHeader.header];
      this.jdtHeader.zh = this.authService.zh.home[this.jdtHeader.header];
      this.euspHeader.zh = this.authService.zh.home[this.euspHeader.header];
      this.categoriesHeader.zh = this.authService.zh.home[this.categoriesHeader.header];



      this.columns.forEach(item => {
        item.en = this.authService.en.home[item.header];
      });
      this.categoryList.forEach(item => {
        item.en = this.authService.en.departmentsData[item.name];
      });
      this.featuredProductsHeader.en = this.authService.en.home[this.featuredProductsHeader.header];
      this.bestsellersHeader.en = this.authService.en.home[this.bestsellersHeader.header];
      this.popularCategoriesHeader.en = this.authService.en.home[this.popularCategoriesHeader.header];
      this.newArrivalsHeader.en = this.authService.en.home[this.newArrivalsHeader.header];
      this.superLowDealHeader.en = this.authService.en.home[this.superLowDealHeader.header];
      this.wenProductHeader.en = this.authService.en.home[this.wenProductHeader.header];
      this.weiniSpecialHeader.en = this.authService.en.home[this.weiniSpecialHeader.header];
      this.flashSaleHeader.en = this.authService.en.home[this.flashSaleHeader.header];
      this.ppHeader.en = this.authService.en.home[this.ppHeader.header];
      this.mltHeader.en = this.authService.en.home[this.mltHeader.header];
      this.jdtHeader.en = this.authService.en.home[this.jdtHeader.header];
      this.euspHeader.en = this.authService.en.home[this.euspHeader.header];
      this.categoriesHeader.en = this.authService.en.home[this.categoriesHeader.header];

    }

    getHomeProductList(){
      this.bannerCategoryLoad = false;
      this.authService.start();
      this.authService.getHomeProductList().subscribe(
          data => {
            if(data['status'] == 'ok'){
              this.loading = false;
              var assets = data['result'].assetList;
              this.slideList = [];
              assets.slice().reverse().forEach(a => {
                if(a.type == "SLIDE"){
                  this.slideList.push(a);
                }else if(a.type == "SIDE"){
                  this.banner = a;
                }
              });
              // this.list1 = data['result'].list1;
              this.list2 = data['result'].list2;
              this.list3 = data['result'].list3;
              // this.list4 = data['result'].list4;
              // this.list5 = data['result'].list5;
              // this.list6 = data['result'].list6;
              this.superLowDealList = data['result'].superLowDealList;
              this.wenProductList = data['result'].wenProductList;
              this.weiniSpecialList = data['result'].weiniSpecialList;
              this.virtualProductList = data['result'].virtualProductList;
              this.pointSectionList = data['result'].pointSectionList;
              this.merchants = data['result'].storeList;
              this.ppProductList = data['result'].ppProductList;
              this.mltProductList = data['result'].mltProductList;
              this.jdtProductList = data['result'].jdtProductList;
              this.euspProductList = data['result'].euspProductList;
              // this.list1.forEach(p => {
              //   p.routerLink = '../shop/custom-product/' + p.id;
              // });
              this.list2.forEach(p => {
                p.routerLink = '../shop/custom-product/' + p.id;
              });
              this.list3.forEach(p => {
                p.routerLink = '../shop/custom-product/' + p.id;
              });
              // this.list4.forEach(p => {
              //   p.routerLink = '../shop/custom-product/' + p.id;
              // });
              // this.list5.forEach(p => {
              //   p.routerLink = '../shop/custom-product/' + p.id;
              // });
              // this.list6.forEach(p => {
              //   p.routerLink = '../shop/custom-product/' + p.id;
              // });
              this.superLowDealList.forEach(p => {
                p.routerLink = '../shop/custom-product/' + p.id;
              });
              this.virtualProductList.forEach(p => {
                p.routerLink = '../shop/custom-product/' + p.id;
              });
              this.pointSectionList.forEach(p => {
                p.showPointOnly = true;
                p.routerLink = '../shop/custom-product/' + p.id;
              });
              this.merchants.forEach(p => {
                p.routerLink = '/classic/shop/merchant/' + p.id;
              });
              this.wenProductList.forEach(p => {
                p.routerLink = '../shop/custom-product/' + p.id;
              });
              this.weiniSpecialList.forEach(p => {
                p.routerLink = '../shop/custom-product/' + p.id;
              });
              this.ppProductList.forEach(p => {
                p.routerLink = '../shop/custom-product/' + p.id;
              });
              this.mltProductList.forEach(p => {
                p.routerLink = '../shop/custom-product/' + p.id;
              });
              this.jdtProductList.forEach(p => {
                p.routerLink = '../shop/custom-product/' + p.id;
              });

              this.categories = [];
              var list = data['result'].categoryList;
              list.forEach(c => {
                var image = 'assets/images/categories/bag.svg';
                if(c.id == 41){
                  image = 'assets/images/categories/shoes.svg';
                }else if(c.id == 53){
                  image = 'assets/images/categories/homelifestyle.svg';
                }else if(c.id == 51){
                  image = 'assets/images/categories/bag.svg';
                }else if(c.id == 57){
                  image = 'assets/images/categories/healthcare.svg';
                }else if(c.id == 39){
                  image = 'assets/images/categories/beautycare.svg';
                }else if(c.id == 50){
                  image = 'assets/images/categories/hats.svg';
                }else if(c.id == 49){
                  image = 'assets/images/categories/mensfashion.svg';
                }else if(c.id == 48){
                  image = 'assets/images/categories/ladiesfashion.svg';
                }else if(c.id == 46){
                  image = 'assets/images/categories/cnyspecial.svg';
                }else if(c.id == 47){
                  image = 'assets/images/categories/groceries.svg';
                }else if(c.id == 55){
                  image = 'assets/images/categories/babbies.svg';
                }else if(c.id == 54){
                  image = 'assets/images/categories/electronics.svg';
                }else if(c.id == 52){
                  image = 'assets/images/categories/sports.svg';
                }else if(c.id == 56){
                  image = 'assets/images/categories/pets.svg';
                }
                
                var item = {
                  category: c,
                  url: '../shop/' + c.id,
                  image: image
                };
                if(c.id != 37){ //exclude weini special
                  this.categories.push(item);
                }
              });

              this.bannerCategoryLoad = true;

              // this.columns = [
              //     {
              //         header: 'topRatedProducts',
              //         products: this.list4.slice(0, 3),
              //         en: "",
              //         zh: ""
              //     },
              //     {
              //         header: 'specialOffers',
              //         products: this.list5.slice(3, 6),
              //         en: "",
              //         zh: ""
              //     },
              //     {
              //         header: 'bestsellers',
              //         products: this.list6.slice(6, 9),
              //         en: "",
              //         zh: ""
              //     }
              // ];

              // this.initTranslate();
            }else if(data['status'] == 'error'){
              this.authService.showToast("danger", data['errorMessage']);
            }else{
              this.authService.showToast("danger", this.authService.getTranslation("message.generalError"));
            }
            this.initTranslate();
            this.detectChange();
            this.authService.complete();
          },
          error => {
            if(error['error'].errorCode == 400){
              this.authService.showToast("danger", error['error'].message);
            }
            this.authService.complete();
          }
        );
    }

    //deprecated
    getCategoryList(){
      this.bannerCategoryLoad = false;
      this.authService.start();
      this.authService.getAllCategoryList().subscribe(
          data => {
            if(data['status'] == 'ok'){
              this.categories = [];
              var list = data['result'];
              list.forEach(c => {
                var image = 'assets/images/categories/bags.jpg';
                if(c.id == 43){
                  image = 'assets/images/categories/shoeshats.jpg';
                }else if(c.id == 42){
                  image = 'assets/images/categories/watches.jpg';
                }else if(c.id == 41){
                  image = 'assets/images/categories/bags.jpg';
                }else if(c.id == 40){
                  image = 'assets/images/categories/healthcare.jpg';
                }else if(c.id == 39){
                  image = 'assets/images/categories/beauty.jpg';
                }else if(c.id == 38){
                  image = 'assets/images/categories/accessories.jpg';
                }else if(c.id == 28){
                  image = 'assets/images/categories/mensfashion.jpg';
                }else if(c.id == 27){
                  image = 'assets/images/categories/womenfashion.jpg';
                }
                var item = {
                  category: c,
                  url: '../shop/' + c.id,
                  image: image
                };
                if(c.id != 37){ //exclude weini special
                  this.categories.push(item);
                }
              });

              this.bannerCategoryLoad = true;
            }else if(data['status'] == 'error'){
              this.authService.showToast("danger", data['errorMessage']);
            }else{
              this.authService.showToast("danger", this.authService.getTranslation("message.generalError"));
            }
            this.detectChange();
            this.authService.complete();
          },
          error => {
            if(error['error'].errorCode == 400){
              this.authService.showToast("danger", error['error'].message);
            }
            this.authService.complete();
          }
        );
    }

    showNoticeDialog(): void {
      const dialogRef = this.dialog.open(NoticeComponent, {
        width: '650px',
        data: {

        }
      });

      dialogRef.afterClosed().subscribe(result => {

      });
    }

    getProfile(){
      this.authService.start();
      this.authService.getProfile().subscribe(
          data => {
            if(data['status'] == 'ok'){
              this.authService.weniValue = data['result'].weni;
              this.authService.usdtValue = data['result'].usdt;
              this.authService.usdtPointValue = data['result'].usdtPoint;
              this.authService.weniTokenValue = data['result'].weniToken;
              this.authService.otrValue = data['result'].otr;
              this.authService.lpValue = data['result'].lp;
              this.authService.pvValue = data['result'].pv;
              this.authService.ppValue = data['result'].pp;
              this.authService.mltValue = data['result'].mlt;
              this.authService.jdtValue = data['result'].jdt;
              // this.authService.euspValue = data['result'].eusp;
              this.authService.userCoinList = data['result'].userCoinList;
              this.authService.cashVoucher = data['result'].cashVoucher;
              this.authService.consumerVoucher = data['result'].consumerVoucher;
              this.authService.rebates = data['result'].rebates;
              this.authService.points = data['result'].points;
            }
            this.detectChange();
            this.authService.complete();
          },
          error => {
            if(error['error'].errorCode == 400){
              // this.authService.showToast("danger", error['error'].message);
            }
            this.authService.complete();
          }
        );
    }

    checkSso(sessionId) {
      this.authService.checkSso(sessionId).subscribe(
          data => {
            if(data['status'] == 'ok'){
              try{
                this.authService.setToken(data['result'].user.token);
                this.authService.getToken();
                this.cart.load();
                this.authService.weniValue = data['result'].user.weni;
                this.authService.usdtValue = data['result'].user.usdt;
                this.authService.usdtPointValue = data['result'].user.usdtPoint;
                this.authService.weniTokenValue = data['result'].user.weniToken;
                this.authService.otrValue = data['result'].user.otr;
                this.authService.lpValue = data['result'].user.lp;
                this.authService.pvValue = data['result'].user.pv;
                this.authService.ppValue = data['result'].user.pp;
                this.authService.mltValue = data['result'].user.mlt;
                this.authService.jdtValue = data['result'].user.jdt;
                // this.authService.euspValue = data['result'].user.eusp;
                this.authService.userCoinList = data['result'].user.userCoinList;

                this.authService.updateMobileMenu();

                // if(this.authService.loginToCheckout){
                //   this.authService.loginToCheckout = false;
                //   this.authService.router.navigate(['/classic/shop/checkout']);
                // }else{
                //   this.authService.loginToCheckout = false;
                //   this.authService.router.navigate(['/classic/home']);
                // }
              }catch(err){
                // this.authService.router.navigate(['/classic/home']);
              }
            }else if(data['status'] == 'error'){
              // this.authService.showToast("danger", data['errorMessage']);
              // this.authService.router.navigate(['/classic/home']);
            }else{
              // this.authService.showToast("danger", this.authService.getTranslation("message.generalError"));
              // this.authService.router.navigate(['/classic/home']);
            }
            // this.calledAPI = false;
            this.detectChange();
            this.authService.complete();
            this.authService.loadingSso = false;
          },
          error => {
            if(error['error'].errorCode == 400){
              // this.authService.showToast("danger", error['error'].message);
            }
            // this.calledAPI = false;
            this.authService.complete();
            // this.authService.router.navigate(['/classic/home']);
          }
        );
    }

    getFlashSaleProductList(status){
      this.authService.start();
      this.authService.getFlashSaleProductList(1, 20, status).subscribe(
          data => {
            if(data['status'] == 'ok'){
              var list = data['result'].productList;
              list.forEach(p => {
                p.routerLink = '../shop/custom-product/' + p.id;
              });

              if(status == "START"){
                if(this.flashSaleProductList.length != list.length){
                  this.flashSaleProductList = list;
                }else if(this.flashSaleProductList.length > 0){
                  var dif = false;
                  this.flashSaleProductList.forEach((p, index) => {
                    if(!dif){
                      if(p.id != list[index].id){
                        dif = true;
                      }else if(p.status != list[index].status){
                        dif = true;
                      }else if(p.startDate != list[index].startDate){
                        dif = true;
                      }
                    }
                  });
                  if(dif){
                    this.flashSaleProductList = list;
                  }
                }
              }else if(status == "PENDING"){
                if(this.pendingFlashSaleProductList.length != list.length){
                  this.pendingFlashSaleProductList = list;
                }else if(this.pendingFlashSaleProductList.length > 0){
                  var dif = false;
                  this.pendingFlashSaleProductList.forEach((p, index) => {
                    if(!dif){
                      if(p.id != list[index].id){
                        dif = true;
                      }else if(p.status != list[index].status){
                        dif = true;
                      }else if(p.startDate != list[index].startDate){
                        dif = true;
                      }
                    }
                  });
                  if(dif){
                    this.pendingFlashSaleProductList = list;
                  }
                }
              }
            }else if(data['status'] == 'error'){
              this.authService.showToast("danger", data['errorMessage']);
            }else{
              this.authService.showToast("danger", this.authService.getTranslation("message.generalError"));
            }
            this.detectChange();
            this.authService.complete();
          },
          error => {
            if(error['error'].errorCode == 400){
              this.authService.showToast("danger", error['error'].message);
            }
            this.authService.complete();
          }
        );
    }

    startInterval(){
      this.interval = setInterval(()=>{
        this.getFlashSaleProductList("START");
        // this.getFlashSaleProductList("PENDING");
      }, 5000);
    }

    stopInterval(){
      clearInterval(this.interval);
    }

    getNewProductList(){
      this.authService.start();
      this.newArrivalPage += 12;
      console.log('newArrivalLoadMore2 ' + this.newArrivalPage);
      this.authService.getNewArrivalProductList(this.newArrivalPage, 12).subscribe(
          data => {
            if(data['status'] == 'ok'){
              var list = data['result'];
              list.forEach(p => {
                p.routerLink = '../shop/custom-product/' + p.id;
              });
              this.list3.push.apply(this.list3, list);
            
            }else if(data['status'] == 'error'){
              this.authService.showToast("danger", data['errorMessage']);
            }else{
              this.authService.showToast("danger", this.authService.getTranslation("message.generalError"));
            }
            this.detectChange();
            this.authService.complete();
          },
          error => {
            if(error['error'].errorCode == 400){
              this.authService.showToast("danger", error['error'].message);
            }
            this.authService.complete();
          }
        );
    }

    newArrivalLoadMore() {
      console.log('newArrivalLoadMore');
      this.getNewProductList();
    }
    
    getProductSearchList(){
      this.authService.start();
      this.authService.getProductSearchList().subscribe(
          data => {
            if(data['status'] == 'ok'){
              this.cloudData = data['result'].map(result => ({
                text: result.search,
                weight: result.count,
                color: this.getRandomColor()
              }));
            }
            this.detectChange();
            this.authService.complete();
          },
          error => {
            if(error['error'].errorCode == 400){
              // this.authService.showToast("danger", error['error'].message);
            }
            this.authService.complete();
          }
        );
    }

    getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    }
}
